import React, { useEffect } from "react";
import { withFormik } from "formik";

import { Visible } from "../../../core/components";
import { FieldGroup } from "../../../components";
import { Button } from "../../../components/ui";
import {
  yearOptions,
  boxOptions,
  conditionOptions,
  sourceOptions,
  locationOptions,
  priceSortByOptions,
} from "../../../product/constants";
import { MarketplaceActions } from "../../../order/atoms";

const option = (name) => ({ id: " ", name });

const PriceFilters = ({
  user,
  onFiltersChange,
  values,
  handleReset,
  product,
}) => {
  useEffect(() => {
    const { year, box, condition, source, location, priceSortBy } =
      values || {};

    const hasValidValue = [
      year,
      box,
      condition,
      source,
      location,
      priceSortBy,
    ].some((v) => v?.toString()?.trim());

    if (hasValidValue) {
      onFiltersChange({
        year: values?.year?.toString()?.trim() || undefined,
        box: values?.box?.trim() || undefined,
        condition: values?.condition?.trim() || undefined,
        source: values?.source?.trim() || undefined,
        location: values?.location?.trim() || undefined,
        priceSortBy: values?.priceSortBy?.trim() || undefined,
      });
    }
  }, [values]);

  return (
    <div className="rc-price-filters">
      <div className="rc-price-filters__grid">
        <FieldGroup
          name="year"
          type="select"
          options={[option("Year"), ...yearOptions]}
          defaultValue={[option("Year")]}
        />
        <FieldGroup
          name="box"
          type="select"
          options={[option("Delivery Set"), ...boxOptions]}
          defaultValue={[option("Delivery Set")]}
        />
        <FieldGroup
          name="condition"
          type="select"
          options={[option("Condition"), ...conditionOptions]}
          defaultValue={[option("Condition")]}
        />
        <Button variant="ghost" data-btn="price-filter-clear" onClick={handleReset}>
          Clear
        </Button>
        <div className="rc-price-filters__marketplace">
          <MarketplaceActions item={product} fieldClassName="" />
        </div>
      </div>
      <Visible when={user?.is_admin}>
        <div className="rc-price-filters__grid rc-price-filters__grid--secondary">
          <FieldGroup
            name="source"
            type="select"
            options={[option("Source"), ...sourceOptions]}
            defaultValue={[option("Source")]}
          />
          <FieldGroup
            name="location"
            type="select"
            options={[option("Country"), ...locationOptions]}
            defaultValue={[option("Country")]}
          />
          <FieldGroup
            name="priceSortBy"
            type="select"
            options={priceSortByOptions}
            defaultValue={priceSortByOptions[0]}
          />
        </div>
      </Visible>
    </div>
  );
};

export default withFormik({
  mapPropsToValues: (props) => props.initialValues || props.values || {},
  enableReinitialize: true,
})(PriceFilters);
